import {
  POST_IP_CHECK_REQUEST,
  POST_IP_CHECK_SUCCESS,
  POST_IP_CHECK_FAILURE,
} from '../../constants/ActionTypes';
import { CommonApi } from '../api/CommonApi';

export const postIpCheckRequest = () => ({
  type: POST_IP_CHECK_REQUEST,
});

export const postIpCheckSuccess = (data) => ({
  type: POST_IP_CHECK_SUCCESS,
  payload: {
    enabled: data.enabled,
  },
});

export const postIpCheckFailure = (error) => ({
  type: POST_IP_CHECK_FAILURE,
  payload: {
    error: error,
  },
});

export const postIpCheck = (type) => {
  return (dispatch) => {
    dispatch(postIpCheckRequest());
    CommonApi.postIpCheck(type, dispatch)
      .then((response) => {
        dispatch(postIpCheckSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postIpCheckFailure(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/Ip.js